import type { FC } from 'react'
import { IconButton } from '@mui/material'
import { Save } from '@dhl/icons'
import { StyledIconBox } from './StyledIconBox.js'

type Props = {
  isDisabled?: boolean
  onClick?: () => void
  dataTest?: string
}
export const SubmitButton: FC<Props> = ({ dataTest = 'save-parcel', isDisabled, onClick }) => (
  <StyledIconBox>
    <IconButton
      type="submit"
      size="large"
      data-testid={dataTest}
      aria-label="submit"
      disabled={isDisabled}
      onClick={onClick}
    >
      <Save />
    </IconButton>
  </StyledIconBox>
)
